<script>
export default {}
</script>

<template>
	<CheckoutPaymentCardContent icon="bank" title="Depósito o Transferencia bancaria">
	</CheckoutPaymentCardContent>
</template>
